import { getSlotType as e } from "../utils.js";

import { groupBy as r, keyBy as t } from "lodash";

import { createContext as a, useContext as n, useState as o, useCallback as i, useMemo as s } from "react";

const l = {
    primary: {
        textMain: "text-primary-600",
        textMainDark: "text-primary-700",
        bgMain: "bg-primary-600",
        bgLight: "bg-primary-90",
        buttonMain: "btn-primary",
        buttonOutlined: "btn-primary-outlined",
        buttonBorderless: "btn-primary-borderless",
        weekDayButtonActive: "bg-primary-200 border-primary-300 text-primary-700 hover:bg-primary-200/70",
        textLink: "text-link-primary",
        availableSlotCount: "bg-primary-100 border-primary-700 text-primary-700",
        availableSlotCountLabel: "text-primary-700",
        availableSlot: "bg-primary-100 border-l-primary-700"
    },
    secondary: {
        textMain: "text-secondary-700",
        textMainDark: "text-secondary-800",
        bgMain: "bg-secondary-600",
        bgLight: "bg-secondary-100",
        buttonMain: "btn-secondary",
        buttonOutlined: "btn-secondary-outlined",
        buttonBorderless: "btn-secondary-borderless",
        weekDayButtonActive: "bg-secondary-200 border-secondary-300 text-secondary-700 hover:bg-secondary-200/70",
        textLink: "text-link-secondary",
        availableSlotCount: "bg-secondary-200 border-secondary-700 text-secondary-700",
        availableSlotCountLabel: "text-secondary-700",
        availableSlot: "bg-secondary-200 border-l-secondary-700"
    }
}, d = {
    available: 0,
    new: 0,
    follow_up: 0
}, b = a => {
    const [n, b] = o(!1), [y, c] = o(null), m = i(((e, r) => () => {
        c(e && r || null), b(e);
    }), []), {colorVariant: u = "primary", slots: p, schedules: g, isFetchingSchedules: x, isSlotsFetching: h, isDeleting: S, isSubmittingSchedule: D} = a, v = l[u] || l.primary, w = s((() => {
        const t = r(p || [], e);
        return Object.entries(t).reduce(((e, [r, t]) => ({
            ...e,
            [r]: t?.length || 0
        })), d);
    }), [ p ]), M = s((() => t(g || [], "id")), [ g ]), k = !!(x || h || S || D);
    return {
        ...a,
        variantClassNames: v,
        toggleDrawer: m,
        isDrawerOpened: n,
        drawerSlotsFilter: y,
        slotsCounts: w,
        schedulesMap: M,
        isEditOrDeleteDisabled: k
    };
}, y = a({
    colorVariant: "primary",
    isMobile: !1,
    mode: "week",
    onChangeMode: () => {},
    date: new Date,
    onChangeDate: () => {},
    submitSchedule: () => {},
    variantClassNames: l.primary,
    isDrawerOpened: !1,
    toggleDrawer: () => () => {},
    drawerSlotsFilter: null,
    slotsCounts: d,
    deleteSlot: async () => ({
        message: ""
    }),
    deleteSchedule: async () => ({
        message: ""
    }),
    minTimeSegmentDuration: 30,
    schedulesMap: {},
    contactSupportLink: "",
    isEditOrDeleteDisabled: !1
}), c = () => n(y);

export { y as ProviderScheduleContext, c as useProviderSchedule, b as useProviderScheduleModel };
//# sourceMappingURL=useProviderSchedule.js.map
